<template>
  <div class="px-4 py-2">
    <h1 class="mb-2 text-lg font-medium">
      Employee application UI configurations
    </h1>
    <div
      class="flex align-center space-x-4 border border-blue-200 bg-white dark-bg-custom px-6"
      :class="index < appConfigOptions?.length - 1 ? 'border-b-0' : ''"
      v-for="(configOption, index) in appConfigOptions"
      :key="index"
    >
      <div>{{ configOption.label }}</div>
      <div class="flex align-center justify-end">
        <v-label>{{ configOption.deactivateLabel }}</v-label>
        <v-switch
          :ripple="false"
          class="ml-5 mb-1"
          inset
          dense
          :label="configOption.activateLabel"
          v-model="configOption.enabled"
          @change="updateAppConfig"
        ></v-switch>
      </div>
    </div>
    <div class="mt-5 border border-blue-200 p-8">
      <v-row class="flex justify-between">
        <h1 class="text-lg font-medium">Dashboard Customization</h1>
        <v-btn color="primary" @click="saveFilterChanges">Save Changes</v-btn>
      </v-row>
      <AppFilterCustomization
        ref="dashboardFilters"
        :receivedData="receivedData"
      />
    </div>
  </div>
</template>
<script>
import { orgConfigSuccess, orgConfigError } from "@/utils/toastMessages";
import AppFilterCustomization from "./AppFilterCustomization";

export default {
  props: {
    receivedData: {
      type: Object,
      default: null,
    },
  },
  components: {
    AppFilterCustomization,
  },
  data() {
    return {
      appConfigOptions: [
        {
          label: "Enable Clock In / Clock Out",
          deactivateLabel: "Deactivate",
          activateLabel: "Activate",
          enabled: false,
        },
        {
          label: "Create New Task",
          deactivateLabel: "Deactivate",
          activateLabel: "Activate",
          enabled: false,
        },
        {
          label: "Create Recurring Task",
          deactivateLabel: "Deactivate",
          activateLabel: "Activate",
          enabled: false,
        },
        {
          label: "Employee can close the case/visit",
          deactivateLabel: "Deactivate",
          activateLabel: "Activate",
          enabled: false,
        },
      ],
      taskSteps: null,
      taskTypes: null,
      dashboardFilters: null,
    };
  },
  methods: {
    async updateAppConfig() {
      const isCheckInAllowed = this.appConfigOptions[0].enabled;
      const isTaskCreationAllowed = this.appConfigOptions[1].enabled;
      const isTaskRecurrenceAllowed = this.appConfigOptions[2].enabled;
      const isClosingCaseAllowed = this.appConfigOptions[3].enabled;
      if (this.receivedData.taskCompletionSteps.type === "CUSTOM") {
        this.taskSteps = this.receivedData.taskCompletionSteps.config;
        this.taskTypes = "CUSTOM";
      } else {
        this.taskSteps = this.receivedData.taskCompletionSteps.default;
        this.taskTypes = "DEFAULT";
      }
      const requestBody = {
        isCheckInAllowed,
        isTaskCreationAllowed,
        isTaskRecurrenceAllowed,
        isClosingCaseAllowed,
        taskCompletionStepsConfig: this.taskSteps,
        type: this.taskTypes,
      };
      await this.postConfig(requestBody);
    },
    async postConfig(data) {
      try {
        await this.$axios
          .post("/workforce/org/config", data)
          .then(() => {
            this.$toast.success(orgConfigSuccess);
          })
          .catch((error) => {
            this.$toast.error(orgConfigError);
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    getData() {
      this.appConfigOptions[0].enabled = this.receivedData.isCheckInAllowed;
      this.appConfigOptions[1].enabled =
        this.receivedData.isTaskCreationAllowed;
      this.appConfigOptions[2].enabled =
        this.receivedData.isTaskRecurrenceAllowed;
      this.appConfigOptions[3].enabled = this.receivedData.isClosingCaseAllowed;
    },
    async saveFilterChanges() {
      const filterConfig = this.$refs.dashboardFilters.saveChanges();
      const data = {
        appDashboardCustomization: filterConfig,
      };
      await this.postConfig(data);
    },
  },
  computed: {
    settingLanguage() {
      const Cases = this.receivedData?.enabledUseCases;
      if (Cases && Cases.includes("inventory") && Cases.length > 1) {
        return "Task/Complaint";
      } else if (Cases && Cases.includes("inventory")) {
        return "Complaint";
      } else {
        return "Task";
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style></style>
